import { CustomerSiteOption } from '@/api/customers/types';
import { UserFormModel } from '../types';

export enum SiteSelectType {
	SELECT = 'select',
	MULTISELECT = 'multiselect',
}

export interface CommonSiteSelectProps {
	formModel: UserFormModel;
	updateFormModel: (value: UserFormModel) => void;
	sites?: CustomerSiteOption[];
	disabled?: boolean;
}

export interface SiteSelectProps extends CommonSiteSelectProps {
	type: SiteSelectType;
}
